import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FileUploader } from 'ng2-file-upload';// componente bootstrap per l'upload
import { HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';

import * as _ from "lodash";
import * as fileSaver from 'file-saver';

import { DataService } from '../../services/data.service';

@Component({
	selector: 'app-conversazioni',
	templateUrl: './conversazioni.component.html',
	styleUrls: ['./conversazioni.component.css']
})
export class ConversazioniComponent implements OnInit {
	@ViewChild('conversation') private conversation: ElementRef;
	public headers: HttpHeaders;
	cittadini: any = null;
	cittadini_select : any[] = [];
	cittadini_loaded : boolean = false;

	operatori: any = null;
	operatori_select : any[] = [];
	operatori_loaded : boolean = false;

	conversations_loaded : boolean = false;
	//stati conversazini
	stati: any[] = [
		'aperto',
		'lavorarazione',
		'risolto',
		'non risolvibile',
		'sospeso',
		'attesa'
	];
	private sub: any;
	cittadiniSync: Subscription;
	operatoriSync: Subscription;
	conversation_id: number = null // id conversazione passato tramite parametro url
	destinatario: any = '';
	destinatario_id : number;
	newMsg : string = '';
	new_conversation_title : string = '';
	new_conversation_message : string = '';
	msgList : any[] = []; // lista messaggi conversazione corrente
	mine : boolean = true;
	open_form : boolean = false;// form crea conversazione aperto
	conversation_margin : number = 0;
	conversations : any = null;
	conversations_key :any[] = [];
	active_conversation : any = null;// conversazione attiva
	active_conversation_status : string = null;
	search : any = '';
	fileField: any;
	allegati :any[] = []; // allegati conversazione corrente
	uploader: FileUploader;
	uploadUrl: string = '/api/importa/allegato'; // rotta per upload allegato
	converterUrl: string;
	fileName: string;
	filterConversation: string = "all";
	// estensioni permesse per gli allegati
	accept: string = '.pdf , .xlsx, .xls, .doc, .docx, .zip, .jpg, .jpeg, .png';

	constructor(private route: ActivatedRoute, private dataService: DataService) {
			this.uploader = new FileUploader({url: this.uploadUrl });
			this.uploader.onCompleteAll = () => { this.uploadComplete() };
			this.dataService.getCommon().getSocket().on("updateChat", (params) => {
				console.log('UPDATE CHAT', params);
				if (params.id == this.conversation_id) {
					this.selectConversation(params)
				}
			});
			this.dataService.getCommon().getSocket().on("updateConversations", () => {
				this.loadConversations();
			});
		}

	ngOnInit() {
		//lettura parametro id per aprire conversazione tramite url diretto
		this.sub = this.route.params.subscribe(params => {
			if(params['id']){
				console.log('CONV|PARAM',params['id'])
				this.conversation_id = Number(params['id']);
			}
		});
		this.cittadiniSync = this.dataService.getComuniService().cittadini$.subscribe(
			cittadini => {
				console.log('CITTADINI_CONVERSAZIONI', cittadini);
				this.cittadini_loaded = false;
				this.cittadini = {};
				this.cittadini_select = [];
				for (let cittadino of cittadini) {
					this.cittadini[cittadino.id] = cittadino;
					this.cittadini_select.push({
						id : cittadino.id,
						nomeCompleto : cittadino.nomeCompleto
					});
				}
				this.cittadini_loaded = true,
				this.loadConversations();
			});
		this.operatoriSync = this.dataService.getComuniService().operatori$.subscribe(
			operatori => {
				console.log('OPERATORI_CONVERSAZIONI', operatori);
				this.operatori_loaded = false;
				this.operatori = {};
				for (let operatore of operatori) {
					this.operatori[operatore.id] = operatore;
					this.operatori_select.push({
						id : operatore.id,
						nomeCompleto : operatore.nomeCompleto
					});
				}
				this.operatori_loaded = true;
				this.loadConversations();
			});
	}

	uploadAllegato() {
		this.uploader.queue[0].file.name = Date.now()+"_"+this.uploader.queue[0].file.name;
		this.uploader.queue[0].upload();//effettuo upload
	}

	uploadComplete() {
		let filename = this.uploader.queue[0].file.name;
		let tipo = filename.split('.').pop();
		let allegato = {
			conversazione_id:this.active_conversation.id,
			url:"/import/allegati/"+filename,
			tipo:tipo,
			filename:filename
		}
		let body = JSON.stringify(allegato);
		this.uploader.clearQueue();
		this.fileField = null;
		this.dataService.getCommon().getDB().addAllegatoToConversation(body).subscribe(data=>{
			console.log('CONV|upload complete',data)
			this.selectConversation(this.active_conversation); // aggiorno conversazione
			this.dataService.getCommon().getSocket().emit("updateChat", this.active_conversation); // aggiorno conversazione altri utenti tramite socket
		});
	}

	loadConversations() {
		let comuneId = this.dataService.getComuniService().getComuneId()
		if (comuneId != -1) {
			this.conversations_loaded = false;
			console.log('CONV|loadConversations|START',this.conversation_id);
			if (this.cittadini_loaded && this.operatori_loaded) {
				let filter = {
					user_id: this.dataService.getUtentiService().getUser().id,
					amministratore: false,
					comune_id: comuneId
				}
				if(this.dataService.getUtentiService().getPermissions()){
					filter.amministratore = true;
				}
				let body = filter;
				this.dataService.getCommon().getDB().loadConversations(body).subscribe(
					data => {
						console.log('CONV|loadConversations|DATA', body, data);
						this.conversations = {};
						this.conversations_key = [];
						if(data){
							for (let conversation of data.rows) {
								this.conversations[conversation.id] = conversation;
								this.conversations[conversation.id].active = false;
								this.conversations[conversation.id].messages = [];
								this.conversations_key.push(conversation.id);
								console.log("conversation", conversation, this.dataService.getUtentiService().getUser(), this.cittadini, this.operatori);
								if(conversation.mittente_tipo == "utenti"){
									if (conversation.mittente_id == this.dataService.getUtentiService().getUser().id) {
										this.conversations[conversation.id].author = this.dataService.getUtentiService().getUser().nomeCompleto;
									} else if (this.cittadini[conversation.mittente_id]) {
										this.conversations[conversation.id].author = this.cittadini[conversation.mittente_id].nomeCompleto;
									} else {
										this.conversations[conversation.id].author = this.operatori[conversation.mittente_id].nomeCompleto;
									}
								}else{
									this.conversations[conversation.id].author = "Comune";
								}
							}
							console.log('CONV|loadConversations|KEY',this.conversations_key);
							this.conversations_loaded = true;
							if (this.conversation_id) {
								console.log('CONV|pre select conversation',this.conversation_id);
								let selectedConversation = this.conversations[this.conversation_id];
								this.selectConversation(selectedConversation);
							}
						}
					},
					err => {
						console.log("error conversation:", err);
					}
				);
			}
		}
	}

	ngAfterViewChecked() {
		this.scrollToBottom();
	}

	openForm(){
		this.open_form = true;
	}

	selectDestinatario(e): void {
		this.destinatario_id = e.item.id;
	}

	closeForm() {
		let mittente_tipo;
		let mittente_id;
		let destinatario_tipo;
		if(this.dataService.getUtentiService().getPermissions()){
			mittente_tipo = "comuni";
			destinatario_tipo = "utenti";
			mittente_id = this.dataService.getComuniService().getComuneId();
		}else{
			mittente_tipo = "utenti";
			destinatario_tipo = "comuni";
			this.destinatario_id = this.dataService.getComuniService().getComuneId();
			mittente_id = this.dataService.getUtentiService().getUser().id;
		}
		this.open_form = false;
		let new_conversation = {
			mittente_id : mittente_id,
			mittente_tipo : mittente_tipo,
			destinatario_id : this.destinatario_id,
			destinatario_tipo : destinatario_tipo,
			comune_id : this.dataService.getComuniService().getComuneId(),
			oggetto : this.new_conversation_title,
		}

		let data_to_sent = {
			conversation : new_conversation,
			messaggio : this.new_conversation_message,
			codicecomune : this.dataService.getComuniService().getComuneCodice(),
		}

		let body = JSON.stringify(data_to_sent);
		this.dataService.getCommon().getDB().createConversation(body).subscribe(data=>{
			console.log('CONV|create conversation',data);
			if(!data.error){
				this.new_conversation_title = "";
				new_conversation['active'] = false;
				new_conversation['status'] = "aperto";
				new_conversation['id'] = data.rows.insertId;
				if(new_conversation.mittente_tipo=="utenti"){
					new_conversation['author'] = this.cittadini[new_conversation.mittente_id].nomeCompleto;
				}
				else{
					new_conversation['author'] = "Comune";
				}
				this.conversations[data.rows.insertId]=new_conversation;
				this.conversations_key.unshift(data.rows.insertId);
				this.selectConversation(new_conversation);
				let new_conversation_message = {
					conversazione_id: data.rows.insertId,
					autore_id: this.dataService.getUtentiService().getUser().id,
					testo: this.new_conversation_message
				}
				body = JSON.stringify(new_conversation_message);

				this.dataService.getCommon().getDB().addMessageToConversation(body).subscribe(data=>{
					console.log('CONV|addMessageToConversation',data)
					if(!data.error){
						this.new_conversation_message = "";
						new_conversation_message['mine'] = true;
						this.selectConversation(new_conversation);
						this.dataService.getCommon().getSocket().emit("updateConversations", new_conversation);

						this.sendMsgNotification(new_conversation_message, data);
					}
				});

			}
		});
	}

	downloadAllegato(filename){
		let file = {
			filename:filename
		}
		let body = JSON.stringify(file);
		this.dataService.getCommon().getDB().downloadAllegatoFromConversation(body).subscribe(
			(response) => {
				console.log('CONV|downloadAllegatoFromConversation',response);
				let blob = new Blob([response.blob()]);
				fileSaver.saveAs(blob, filename.slice(14));
				this.dataService.setLoading(false);
			}
		);
	}

	goToConversation(conversation){
		this.dataService.navigateByUrl('/conversazioni/'+conversation.id);
		this.selectConversation(this.conversations[conversation.id]);
	}

	deleteForm(){
		this.open_form = false;
		console.log(this.open_form);
		this.new_conversation_title = "";
		this.new_conversation_message = "";
	}

	confirmUpdateConversation(conversation) {
		let titleConfirm = "Richiesta conferma";
		let confirmContent = "Vuoi veramente cambiare lo stato del ticket "+conversation.oggetto+"?";
		this.dataService.openConfirm(
			titleConfirm,
			confirmContent,
			() => {
				conversation.status = this.active_conversation_status;
				this.updateConversation(conversation);
			},
			() => {
				this.active_conversation_status = conversation.status;
			}
		);
	}

	//aggiorna stato conversazione
	updateConversation(conversation){
		if(conversation.status=="risolto" || conversation.status=="non risolvibile" ){
			var date;
			date = new Date();
			date = date.getUTCFullYear() + '-' +
				('00' + (date.getMonth()+1)).slice(-2) + '-' +
				('00' + date.getDate()).slice(-2) + ' ' +
				('00' + date.getHours()).slice(-2) + ':' +
				('00' + date.getMinutes()).slice(-2) + ':' +
				('00' + date.getSeconds()).slice(-2);
			conversation.data_fine = date;
		}
		else{
			conversation.data_fine = null;
		}
		let body = JSON.stringify(conversation);
		this.dataService.getCommon().getDB().updateConversation(body).subscribe(data=>{
			console.log('CONV|updateConversation',data);
			if(!data.error){
				this.dataService.getCommon().getSocket().emit("updateConversations", conversation);
				this.dataService.getCommon().getSocket().emit("updateChat", conversation);

			}
		});
	}

	scrollToBottom(): void {
		try {
			this.conversation.nativeElement.scrollTop = this.conversation.nativeElement.scrollHeight;
		} catch(err) { }
	}

	selectConversation(active_conversation) {
		console.log('CONV|selectConversation',active_conversation,this.conversations_loaded,this.conversations,this.conversations_key);
		if (active_conversation && this.conversations_loaded) {
			// disattivo tutte le conversazioni
			for(let key of this.conversations_key) {
				this.conversations[key].active = false;
			}
			// setto come attiva la conversaione selezionata
			active_conversation.active = true;
			this.active_conversation = active_conversation;
			this.active_conversation_status = active_conversation.status;
			console.log('CONV|SELECT CONVERSATION',this.active_conversation.status, this.active_conversation_status);
			// effettuo chiamate ajax per prendere i messaggi
			let conversation_id = {
				conversation_id: active_conversation.id
			}
			let body = conversation_id;
			this.dataService.getCommon().getDB().getConversationMessages(body).subscribe(data=>{
				if(!data.err){
					let messages = [];
					for (let message of data.rows) {
						if(message.autore_id == this.dataService.getUtentiService().getUser().id){
							message['mine'] = true;
						}
						else{
							message['mine'] = false;
						}
						messages.push(message);
					}
					this.msgList = messages; // visualizzo i messaggi
					this.dataService.getCommon().getDB().getConversationAllegati(body).subscribe(data=>{
						if(!data.error){
							this.allegati = [];
							for (var allegato of data.rows) {
								allegato["original_filename"] = allegato.filename.slice(14);
								this.allegati.push(allegato);
							}
						}
					});
				}
			});
			this.markAsRead();
		} else if (!active_conversation && this.conversations_loaded) {
			console.log('CONV|redirecting');
			this.conversation_id = null;
			this.dataService.navigateByUrl('/conversazioni');
		}
	}

	markAsRead() {
		if (this.active_conversation) {
			const notification = {
				id : null,
				item_id : this.active_conversation.id,
				user_id :this.dataService.getUtentiService().getPermissions() ? this.dataService.getComuniService().getComuneId() : this.dataService.getUtentiService().getUser().id,
				tipo : 'conversazioni'
			}
			console.log('CONV|markAsRead', notification);
			this.dataService.setNotificaRead(notification);
		}
	}

	addNewMsg() {
		if(this.newMsg.trim() && this.newMsg.trim().length){
			let new_conversation_message = {
				conversazione_id: this.active_conversation.id,
				autore_id: this.dataService.getUtentiService().getUser().id,
				testo: this.newMsg
			}
			let body = JSON.stringify(new_conversation_message);

			this.dataService.getCommon().getDB().addMessageToConversation(body).subscribe(data=>{
				console.log('CONV|addMessageToConversation',data);
				if(!data.error){
					new_conversation_message['mine'] = true;
					this.msgList.push(new_conversation_message);
					this.newMsg = '';
					this.dataService.getCommon().getSocket().emit("updateChat",this.active_conversation);

					this.sendMsgNotification(new_conversation_message,data);
				}
			});
		}
	}

	sendMsgNotification(message,data) {
		let user_id = 0;

		if (this.dataService.getUtentiService().getPermissions()) {
			if (this.active_conversation.mittente_id == this.dataService.getComuniService().getComuneId()) {
				user_id = this.active_conversation.destinatario_id;
			}
			else {
				user_id = this.active_conversation.mittente_id;
			}
		} else {
			if (this.active_conversation.mittente_id == this.dataService.getUtentiService().getUser().id) {
				user_id = this.active_conversation.destinatario_id;
			}
			else {
				user_id = this.active_conversation.mittente_id;
			}
		}

		let date = new Date();
		let mysql_date = date.getUTCFullYear() + '-' +
			('00' + (date.getMonth()+1)).slice(-2) + '-' +
			('00' + date.getDate()).slice(-2) + ' ' +
			('00' + date.getHours()).slice(-2) + ':' +
			('00' + date.getMinutes()).slice(-2) + ':' +
			('00' + date.getSeconds()).slice(-2);

		let logo = "/api/comuni/logo/"+this.dataService.getComuniService().getComuneCodice(); // immagine notifica push
		let body = {
			user_id:user_id,
			comune_id:this.dataService.getComuniService().getComuneId(),
			letto:0,
			tipo:"conversazioni",
			item_id:this.active_conversation.id,
			data:mysql_date,
			testo:message.testo,
			titolo:this.active_conversation.oggetto,
			icon: logo
		}
		this.dataService.getCommon().getDB().createNotificaSistema(body).subscribe(data=>{
			console.log('CONV|createNotificaSistema',data);
			if(!data.error){
				let newId = data.rows.insertId;
				body['id'] = newId;
				this.dataService.getCommon().getSocket().notificaSistema(body);
			}
		});
	}

	setDestinatario(event) {
		console.log('CONV|destinatario',this.destinatario);
	}

	statusChange(event) {
		console.log('CONV|statusChange',event.target.value)
		this.active_conversation_status = event.target.value
	}

	ngOnDestroy() {
		this.cittadiniSync ? this.cittadiniSync.unsubscribe() : null;
	}

}
